export const trackGTMEvent = (url) => {
    if (window.dataLayer) {
        window.dataLayer.push({ event: 'pageview', page: url });
    }
};